/* global Liferay */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

class SolaraMdfRequestElement extends HTMLElement {
  connectedCallback() {
    if (!this.root) {
      this.root = createRoot(this);
    }
    this.root.render(<App />);
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

const ELEMENT_ID = 'solara-mdf-request-custom-element';
if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, SolaraMdfRequestElement);
}
